<template>
    <div>
        <div v-if="currentStepId === 1">
            <code-types-list class="mt-8" @changed="typeWasChange" v-if="!code" :selected-type="null"></code-types-list>
            <qr-code-form v-if="code"></qr-code-form>
        </div>

    </div>
</template>

<script>
import NavigationBar from './NavigactionBar.vue'
import CodeTypesList from './CodeTypesList.vue'
import QrCodeForm from './QrCodeForm.vue'
import CodeTypeSelector from "@/scripts/components/app/qrcodes/form/deprecated/CodeTypeSelector.vue";
import {mapActions, mapState} from 'pinia'
import {qrCodeFormStore} from "@/scripts/store/qr_code_form.store";

export default {
    components: {
        NavigationBar,
        CodeTypesList,
        QrCodeForm,
        CodeTypeSelector
    },

    data() {
        return {
            currentStepId: 1,
        }
    },

    computed: {
        ...mapState(qrCodeFormStore, ['code'])
    },

    methods: {
        ...mapActions(qrCodeFormStore, ['initEmptyCode']),

        selectStep(stepId) {
            this.currentStepId = stepId
        },

        typeWasChange(data) {
            this.initEmptyCode(data.type, data.fields)
        }
    }
}
</script>
